import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../components/form.css";
import { auth } from "../firebase.js";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../utilities/AuthContext.js";
import { getDocs, collection, query, where, addDoc } from "firebase/firestore";
import { db } from "../firebase.js";
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const toastOptions = {
    position: "bottom-right",
    autoClose: 8000,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
  };
  const navigate = useNavigate();
  const { login } = useAuth();
  const handleLogin = async (e) => {
    e.preventDefault();
    if (email === "") {
      toast.error("Email is required", toastOptions);
      return;
    } else if (password === "") {
      toast.error("Password is required", toastOptions);
      return;
    }
    let errorMsg = "";
    try {
      const user = await signInWithEmailAndPassword(auth, email, password);
      login(user);
      // User logged in successfully, you can redirect to another page here
      navigate("/");
    } catch (error) {
      console.error(error);
      // Handle Firebase authentication errors here and provide user feedback
      const errorMessage = error.message;
      // You can also access the error code if needed
      const errorCode = error.code;
      // Handle specific error cases if necessary
      if (errorCode === "auth/wrong-password") {
        errorMsg = "Wrong password entered.";
      } else if (errorCode === "auth/user-not-found") {
        errorMsg = "User not found.";
      } else if (errorCode === "auth/invalid-email") {
        errorMsg = "Invalid email format. Please enter a valid email address.";
      } else if (errorCode === "auth/invalid-login-credentials") {
        errorMsg = "Email or Password is incorrect";
      } else {
        errorMsg = error.message;
      }
      toast.error(errorMsg, toastOptions);
    }
  };
  const checkForNewID = async (user) => {
    const q = query(collection(db, "Users"), where("uid", "==", user.uid));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
      // console.log("No such document!");
      const docRef = await addDoc(collection(db, "Users"), {
        uid: user.uid,
        name: user.displayName,
        email: user.email,
        balance: 10,
        history: [],
      });
      // console.log("Document written with ID: ", docRef.id);
    } else {
      // console.log("Document data:", doc.data());
    }
  }
  const loginWithGoogle = async (e) => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      login(user);
      // User signed in with Google successfully
      checkForNewID(user);
      navigate("/");
      // console.log(user);
    } catch (error) {
      // Handle any errors here
      console.error(error);
    }
  };
  return (
    <>
      <div className="form-parent form-parent-auth">
        <form onSubmit={handleLogin}>
          {/* TODO: Update the form action to point to the backend */}
          <div className="form">
            <div>
              <h1 className="text-3xl font-bold">Login</h1>
              <input
                type="text"
                name="mail"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button className="filled">Login</button>
              <span className="divider">&mdash; OR &mdash;</span>
              <button
                className="outline"
                onClick={(e) => {
                  e.preventDefault();
                  loginWithGoogle();
                }}
              >
                Login with Google
              </button>
              <span>
                Don't have an account? <Link to="/signup">Sign Up</Link>{" "}
                instead.
              </span>
            </div>
            <div>
              <img src="/images/auth.png" alt="" />
            </div>
          </div>
        </form>
      </div>
      <ToastContainer />
    </>
  );
}

export default Login;
